import React from 'react';
import {
  getPagePath,
  withLocales,
  withClientConfig
} from '@spotahome/bff/client';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../../api/traditional-login-client';

const defaultLocale = 'en';

const onTraditionalSignupSuccess = () => {
  location.reload();
};

const onTraditionalLoginSuccess = () => {
  location.reload();
};

const traditionalSignupCB = async (name, email, password) =>
  traditionalSignup({ name, email, password });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });

const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};

const withModalProps = () => Component =>
  withClientConfig()(
    withLocales()(({ locales, clientConfig, initialAction, ...restProps }) => {
      const locale = locales ? locales.current : defaultLocale;

      const landlordLoginLink = getPagePath('externals.landlord-panel');
      const landlordSignupLink = getPagePath('externals.landlord-signup');

      const googleLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'google'
        },
        query: { locale, subscribe: 'no' }
      });

      const facebookLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'facebook'
        },
        query: { locale, subscribe: 'no' }
      });

      return (
        <Component
          {...restProps}
          modalProps={{
            landlordLoginLink,
            landlordSignupLink,
            facebookLinks: {
              login: facebookLoginHref,
              signup: facebookLoginHref
            },
            googleLinks: {
              login: googleLoginHref,
              signup: googleLoginHref
            },
            initialAction,
            termsAndConditionsLink: getPagePath(
              'externals.terms-and-conditions'
            ),
            traditionalSignupCB,
            traditionalLoginCB,
            forgotPasswordCB: traditionalForgotPasswordCB,
            renderTraditionalLogin: true,
            onTraditionalLoginSuccess,
            onTraditionalSignupSuccess
          }}
        />
      );
    })
  );

export default withModalProps;
